module.exports = "/lucky-balls/img/drum/drum_loop_033.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_033.png
// module id = 1048
// module chunks = 0